import builder from '../builder';
import CheckCircle1 from '../../streamline-icons/bold/check-circle-1.svg';

export default builder('IconCheckCircle1Bold', CheckCircle1);
